/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { DownloadCardFragment } from "@cosmos/hygraph-schema";

import { cx, css } from "@panda/css";
import { flex } from "@panda/patterns";
import { SystemStyleObject } from "@panda/types";

import { DownloadCard } from "../download-cards/DownloadCard.molecule";

const downloadableStyle: SystemStyleObject = {
	w: "full",
	h: "full",
	gap: "104px",
	"& > .download-card": {
		flexGrow: 1,
		flexBasis: "1/4",
	},
	xlDown: {
		gap: "eds.dimension.56",
	},
	lgDown: {
		gap: "eds.dimension.32",
		flexWrap: "wrap",
		"& > .download-card:nth-child(1)": {
			flexBasis: "100%",
		},
	},
	smDown: {
		gap: "eds.dimension.40",
		"& > .download-card": {
			flexBasis: "full",
		},
	},
};

export type DownloadableProps = {
	cards?: DownloadCardFragment[] | null;
};

export function DownloadableCards({ cards = [] }: DownloadableProps): React.JSX.Element | null {
	if (!cards?.length) return null;
	return (
		<div className={cx("executable", flex({ flexDir: "row" }), css(downloadableStyle))}>
			{cards ? cards.map((card, i) => <DownloadCard key={`card-${i}`} {...card}></DownloadCard>) : undefined}
		</div>
	);
}
